import React from 'react';
import Icon from '../../../components/AppIcon';

const NewsCategoryFilter = ({ selectedCategory, onCategoryChange, stats }) => {
  const categories = [
    {
      id: 'all',
      name: 'All News',
      icon: 'Newspaper',
      color: 'var(--color-primary)',
      count: stats?.total || 0
    },
    {
      id: 'hr',
      name: 'HR & Employment',
      icon: 'Users',
      color: 'var(--color-info)',
      count: stats?.byCategory?.hr || 0
    },
    {
      id: 'payroll',
      name: 'Payroll',
      icon: 'DollarSign',
      color: 'var(--color-success)',
      count: stats?.byCategory?.payroll || 0
    },
    {
      id: 'tax',
      name: 'Tax (SWT)',
      icon: 'Receipt',
      color: 'var(--color-warning)',
      count: stats?.byCategory?.tax || 0
    },
    {
      id: 'minimum_wage',
      name: 'Minimum Wage',
      icon: 'TrendingUp',
      color: 'var(--color-error)',
      count: stats?.byCategory?.minimumWage || 0
    },
    {
      id: 'employment_act',
      name: 'Employment Act',
      icon: 'FileText',
      color: 'var(--color-primary)',
      count: stats?.byCategory?.employmentAct || 0
    },
    {
      id: 'gazette',
      name: 'Gazette',
      icon: 'BookOpen',
      color: 'var(--color-accent)',
      count: stats?.byCategory?.gazette || 0
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-sm font-medium text-foreground mb-3">Filter by Category</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`flex flex-col items-center justify-center p-4 rounded-lg border-2 transition-smooth ${
              selectedCategory === category?.id
                ? 'border-primary bg-primary/10' :'border-border bg-background hover:border-primary/50'
            }`}
          >
            <Icon
              name={category?.icon}
              size={24}
              color={selectedCategory === category?.id ? 'var(--color-primary)' : category?.color}
            />
            <span className="text-xs font-medium text-foreground mt-2 text-center">
              {category?.name}
            </span>
            <span className="text-xs text-muted-foreground mt-1">
              {category?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default NewsCategoryFilter;